import { useQuery } from '@tanstack/react-query';
import axios from 'constants/axios';
import { getOnboardingEligibilityKeys } from './queryKeys';

interface OnboardingEligibilityResponse {
  result: {
    isGeneralOnboardingComplete: boolean;
  };
}

interface UseGetOnboardingEligibilityQueryProps {
  enabled?: boolean;
}

export const useGetOnboardingEligibilityQuery = ({
  enabled = true,
}: UseGetOnboardingEligibilityQueryProps = {}) =>
  useQuery({
    enabled,
    queryKey: getOnboardingEligibilityKeys,
    queryFn: async () => {
      const response = await axios.get<OnboardingEligibilityResponse>(
        '/ticketing/onboarding/eligibility'
      );
      return response.data.result;
    },
    retry: false,
    // Eligibility can flip from false → true within a single session (e.g.
    // the user creates their first board from the general onboarding page,
    // then navigates back into the wizard). Drop the cache on unmount so the
    // next visit to the wizard route always re-checks against the server
    // instead of redirecting based on a stale "not eligible" answer.
    cacheTime: 0,
    staleTime: 0,
  });
